import { render, staticRenderFns } from "./AddNewActionCategory.vue?vue&type=template&id=48d6a36a&scoped=true"
import script from "./AddNewActionCategory.vue?vue&type=script&lang=ts"
export * from "./AddNewActionCategory.vue?vue&type=script&lang=ts"
import style0 from "./AddNewActionCategory.vue?vue&type=style&index=0&id=48d6a36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6a36a",
  null
  
)

export default component.exports